module.exports = __webpack_public_path__ + "static/media/det-logo.3805cf19.png";